import {
  INITIATE_STARTUP_CREATION,
  STARTUP_CREATION_SUCCESS,
  STARTUP_CREATION_FAILURE,
} from "../actions/types";

const initialState = {
  loading: false,
  successMessage: null,
  errorMessage: null,
};

const startupReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIATE_STARTUP_CREATION:
      return { ...state, loading: true, successMessage: null, errorMessage: null };
    case STARTUP_CREATION_SUCCESS:
      return { ...state, loading: false, successMessage: action.payload, errorMessage: null };
    case STARTUP_CREATION_FAILURE:
      return { ...state, loading: false, successMessage: null, errorMessage: action.error };
    default:
      return state;
  }
};

export default startupReducer;
